<template>
    <footer class="text-center text-white">

        <h1>You must login to continue.</h1>    
        <div id="firebaseui-auth-container"></div>

    </footer>
</template>


<script>
import firebase from 'firebase/app'

import db from '@/db'

import * as firebaseui from 'firebaseui'

import 'firebaseui/dist/firebaseui.css'

let ui;
let uiConfig;
export default {
  name: 'Login',
  data () {
    return {

    }
  },
  
 beforeMount(){

    ui = firebaseui.auth.AuthUI.getInstance();

    if (!ui) {
        ui = new firebaseui.auth.AuthUI(firebase.auth())
    }

    var router = this.$router;

    uiConfig = {
        signInSuccessUrl: "/myaccount",
        signInFlow: "popup",
        signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
        
        
        callbacks: {
            //After sign in with Google is successful
            signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                
                //Google access token
                var token = authResult.credential.accessToken;

                var user = authResult.user;

                //console.log(authResult)

                //if the user's database entry doesn't exist, create it
                const usersRef = db.collection("Users").doc(user.uid)
                const listingsRef = db.collection("Listings").doc(user.uid)

                usersRef.get()
                .then(doc => {
                    //if the document exists reload the page
                    if (doc.exists) {
                        router.push(router.history.current.query.redirect)
                    } else {
                        //doc.data() will be undefined in this case
                        //console.log("creating Users document")
                        usersRef
                        .set({
                            sellerLevel: -1,
                            payAddress: '',
                            refundAddress: '',
                            sellerAddress: '',                           
                            purchasedAccounts: []
                        })
                        .then(() => {
                            router.push(router.history.current.query.redirect)
                            //set the listings document too since it shouldnt exist right now either
                                // console.log("creating Listings document")
                                // listingsRef
                                // .set({
                                //     listings: []
                                // })
                                // .then(() => {router.history.current.query.redirect})                            
                        })
                    }
                })

            }
        
        }

    }
    
 },
 mounted: () => {
     ui.start("#firebaseui-auth-container", uiConfig);
 }
    
}
</script>


// WEBPACK FOOTER //
// src/components/Login.vue